<template>
  <div class="container-fluid p-0">
    <Card>
      <template slot="header">
        <h3>لیست بدهکاران</h3>
        <hr />
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-8">
            <div class="row">
              <div class="col-6">
                <small>حداقل میزان بدهی</small>
                <input type="range" class="custom-range" @change="updateTable" min="0" max="250000000" v-model="min" id="customRange2" />
                {{ $Comma3ragham(min) }} &nbsp; ریال
              </div>
              <div class="col-6">
                <small>حداکثر میزان بدهی</small>
                <input type="range" class="custom-range" @change="updateTable" min="0" max="5000000000" v-model="max" id="customRange2" />
                {{ $Comma3ragham(max) }} &nbsp; ریال
              </div>
            </div>
          </div>

          <div class="col-12 m-3" id="Listbedehkar">
            <BnpGrid
              :key="index"
              :IsReport="true"
              :HeaderReport="'لیست بدهکاران '"
              :hasRowNum="true"
              :SumList="['TotallAmount', 'totallTrue', 'totallcheck', 'totallFalse', 'DepositAmountNaghd', 'TotallAmounTamdid', 'TotallAmountGhatei', 'TotalBedehi']"
              :ListCommaReport="['TotallAmount', 'totallTrue', 'totallcheck', 'totallFalse', 'DepositAmountNaghd', 'TotallAmounTamdid', 'TotallAmountGhatei', 'TotalBedehi']"
              :propsColumn="Column"
              :propsRows="Rows"
              :action="false"
              :excel="true"
              :Sortable="true"
            >
              <template slot="TotallAmount" slot-scope="props">
                <span>{{ $Comma3ragham(props.props.TotallAmount) }}</span>
              </template>
              <template slot="TotallAmounTamdid" slot-scope="props">
                <span>{{ $Comma3ragham(props.props.TotallAmounTamdid) }}</span>
              </template>
              <template slot="TotallAmountGhatei" slot-scope="props">
                <span>{{ $Comma3ragham(props.props.TotallAmountGhatei) }}</span>
              </template>
              <template slot="DepositAmountNaghd" slot-scope="props">
                <span>{{ $Comma3ragham(props.props.DepositAmountNaghd) }}</span>
              </template>
              <template slot="totallTrue" slot-scope="props">
                <span>{{ $Comma3ragham(props.props.totallTrue) }}</span>
              </template>
              <template slot="totallcheck" slot-scope="props">
                <span>{{ $Comma3ragham(props.props.totallcheck) }}</span>
              </template>
              <template slot="totallFalse" slot-scope="props">
                <span class="text-warning">{{ $Comma3ragham(props.props.totallFalse) }}</span>
              </template>
              <template slot="TotalBedehi" slot-scope="props">
                <span :class="props.props.TotalBedehi > 0 ? 'text-danger' : 'text-info'">{{ $Comma3ragham(props.props.TotalBedehi) }}</span>
              </template>
              <template slot="LastTamas" slot-scope="props">
                <p>{{ props.props.LastTamasDate }}</p>
                <span v-if="props.props.LastTamas" style="font-size: 12px" :data-title="props.props.LastTamas">{{ props.props.LastTamas.length > 30 ? props.props.LastTamas.substring(0, 30) + (props.props.LastTamas.length > 30 ? '...' : '') : props.props.LastTamas }}</span>
              </template>
              <template slot="CustomerCode" slot-scope="props">
                <a href="javascript:;" @click="$FindeCustomerById('DetailCustomer', props.props.tblCustomerId, false, $event)" @click.middle="$FindeCustomerById('DetailCustomer', props.props.tblCustomerId, false, $event)">{{ props.props.CustomerCode }}</a>
              </template>
            </BnpGrid>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'

export default {
  data() {
    return {
      index: 0,
      max: 5000000000,
      min: 3000000,
      Column: [
        { id: 2416, name: 'CustomerCode', visibility: true, label: 'کد مشتری' },
        { id: 2416, name: 'CustomerName', visibility: true, label: 'نام مشتری' },
        { id: 2416, name: 'TotallAmount', visibility: true, label: ' کل خریدها' },
        { id: 2416, name: 'DepositAmountNaghd', visibility: true, label: 'پرداختی های نقدی ' },
        { id: 2416, name: 'totallcheck', visibility: true, label: 'مبلغ چکها ' },
        { id: 2416, name: 'totallTrue', visibility: true, label: 'مجموع چک پاس شده' },
        { id: 2416, name: 'totallFalse', visibility: true, label: 'مجموع چک پاس نشده' },
        { id: 2416, name: 'TotallAmounTamdid', visibility: true, label: 'نرخ تمدید' },
        { id: 2416, name: 'TotalBedehi', visibility: true, label: 'میزان بدهکاری' },
        { id: 2416, name: 'TotallAmountGhatei', visibility: false, label: ' کل مبلغ قطعی بدهکاری' },
        { id: 2416, name: 'TaskCount', visibility: true, label: 'تعداد هشدار فعال' },
        { id: 2416, name: 'LastTamas', visibility: true, label: 'آخرین تماس' },
      ],
      Rows: [],
      MainList: [],
    }
  },
  components: { Card, BnpGrid },
  methods: {
    // OnDetail(data) {
    //   this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.tblCustomerId } })
    // },
    GetList() {
      var DataAxios = {
        Action: 'Reports/ListBedehkaran',
        Method: 'Get',
        ArryfildValue: null,
      }
      this.$PostData(DataAxios).then((res) => {
        this.Rows = res.ListDeposit
        this.MainList = res.ListDeposit
        this.Rows.forEach((Element) => {
          Element.totallFalse = Element.totallcheck - Element.totallTrue
        })
        this.index++
      })
    },
    updateTable() {
      var temp = JSON.parse(JSON.stringify(this.MainList))

      this.Rows = temp.filter((x) => (x.TotalBedehi >= this.min && x.TotalBedehi <= this.max) || (x.TotallAmounTamdid >= this.min && x.TotallAmounTamdid <= this.max))
      console.log(this.Rows.length)

      this.index++
    },
  },
  created() {
    this.GetList()
  },
}
</script>
<style>
#Listbedehkar table {
  font-size: smaller;
}
</style>
